{
  "heroHeadline": "YaoiGen Vault",
  "heroSubheadline": "An organized premium AI yaoi video vault for Patreon members, arranged by world, pairing, release path, and access tier so the archive is easy to browse before you connect.",
  "announcementText": "Browse previews, join on Patreon, then connect your membership when you want access checked.",
  "primaryCtaText": "Browse free previews",
  "secondaryCtaText": "Connect Patreon",
  "homepagePrimaryCtaLabel": "Join Patreon",
  "libraryCtaHeadline": "Preview the vault. Join Patreon to unlock the full episodes.",
  "seriesCtaHeadline": "Unlock {series} releases on Patreon.",
  "loginJoinLabel": "Join Patreon",
  "loginConnectLabel": "Connect Existing Membership",
  "heroBannerPath": "/assets/hero-vault.svg",
  "heroBackgroundPath": "/assets/hero-vault.svg",
  "fallbackEpisodeArtPath": "/assets/fallback-episode.svg",
  "lockedPreviewArtPath": "/assets/locked-preview.svg",
  "defaultSeriesCoverPath": "/assets/series-cover.svg",
  "startHereIntro": "Browse free previews, join on Patreon when you want membership access, connect Patreon when you are ready, then open posts or protected media through the portal.",
  "freeTierExplanation": "Free visitors can browse catalog pages, inspect preview details, open safe Patreon preview posts, and choose when to join or connect Patreon.",
  "membersTierExplanation": "Members+ unlocks Progressive Cuts and any Platinum releases that have aged into All Paid Members after five calendar months.",
  "platinumTierExplanation": "Platinum unlocks fresh Platinum Early Access releases immediately, plus Members+ Progressive Cuts and All Paid Members releases.",
  "loginPrivacyReassurance": "Patreon login is used only to verify membership server-side. The site stores a signed HTTP-only session and never exposes private destination URLs in public pages.",
  "upgradeCtaText": "Upgrade on Patreon",
  "accentColor": "#e14b63",
  "secondaryAccentColor": "#0f756f",
  "premiumGlow": "medium",
  "cardDensity": "comfortable",
  "featuredSeriesSlugs": [],
  "featuredEpisodeSlugs": [],
  "discoveryShelfOrder": [],
  "hiddenDiscoveryShelves": [],
  "libraryFeaturedOrder": [],
  "homepageShelfOrders": {},
  "seriesEpisodeOrders": {},
  "seriesCoverOverrides": {},
  "episodeArtOverrides": {},
  "navigationItems": [
    { "href": "/", "label": "Home", "icon": "home", "enabled": true },
    { "href": "/start-here", "label": "Start", "icon": "sparkles", "enabled": true, "mobileOptional": true },
    { "href": "/library", "label": "Browse", "icon": "book", "enabled": true },
    { "href": "/series", "label": "Series", "icon": "crown", "enabled": true },
    { "href": "patreon_join", "label": "Join", "icon": "heart", "enabled": true },
    { "href": "/account", "label": "Account", "icon": "user", "enabled": true }
  ]
}
